export const themes= [{ 
    "id": 9,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 4,
        "enableTermsInfo": false,
        "checkoutOptions": [
            1
        ],
        "showAboutInfo": false,
        "showLogo": true,
        "secondLvlTemplate": 2,
        "menuTemplate": 2,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#FFFA78",
            "primaryBg": "#FEFBE9",
            "color": "#014175",
            "primary": "#134473",
            "actionBtn": "#134473",
            "actionBtnText": "#FFFFFF",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#134473",
            "fldColor": "#000000",
            "titleBg": "#134473",
            "titleText": "#000000",
            "confirmBoxBg": "#CCDEDA",
            "confirmBoxText": "#000000",
            "primaryBtn": "#B8A376",
            "primaryBtnText": "#134473",
            "secondaryBtn": "#B8A376",
            "secondaryBtnText": "#FFFFFF",
            "infoBtn": "#014175",
            "infoBtnText": "#E9E4DB",
            "accentBtn": "#134473",
            "accentBtnText": "#FFFFFF",
            "headerBg": "#134473",
            "headerText": "#FFFFFFFF",
            "separatorLine": "",
            "filterBg": "#134473",
            "filterText": "#925E23",
            "filterSelectBg": "#B8A376",
            "filterSelectText": "#FFFFFFFF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},{
    "id": 2,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#005789",
            "primaryBg": "#F4ECDD",
            "color": "#005789",
            "primary": "#005789",
            "actionBtn": "#005789",
            "actionBtnText": "#F7BB3B",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#005789",
            "fldColor": "#0C0727",
            "titleBg": "#F7BB3B",
            "titleText": "#0C0727",
            "confirmBoxBg": "#F7BB3B",
            "confirmBoxText": "#005789",
            "primaryBtn": "#005789",
            "primaryBtnText": "#F7BB3B",
            "secondaryBtn": "#005789",
            "secondaryBtnText": "#F7BB3B",
            "infoBtn": "#005789",
            "infoBtnText": "#F7BB3B",
            "accentBtn": "#005789",
            "accentBtnText": "#F7BB3B",
            "headerBg": "#005789",
            "headerText": "#F7BB3BFF",
            "separatorLine": "",
            "filterBg": "#F7BB3B",
            "filterText": "#0C0727",
            "filterSelectBg": "#005789",
            "filterSelectText": "#F7BB3BFF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "#F7BB3B",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0 ,
            "bg": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},
{
    "id": 4,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "enableTerms": true,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#B3B48B",
            "primaryBg": "#E9CDAE",
            "color": "#000000",
            "primary": "#886806",
            "actionBtn": "#B3B48B",
            "actionBtnText": "#000000",
            "warning": "#F44336",
            "success": "#DE9A45",
            "error": "#F44336",
            "fldBorder": "#6DA57A",
            "fldColor": "#000000",
            "titleBg": "#6DA57A",
            "titleText": "#6DA57A",
            "confirmBoxBg": "#ECEDF4",
            "confirmBoxText": "#B7582C",
            "primaryBtn": "#B3B48B",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#B3B48B",
            "secondaryBtnText": "#000000",
            "infoBtn": "#B3B48B",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#B3B48B",
            "accentBtnText": "#000000",
            "headerBg": "#B3B48B",
            "headerText": "#FFF",
            "separatorLine": "",
            "filterBg": "#B3B48B",
            "filterText": "#000000",
            "filterSelectBg": "#C59B70",
            "filterSelectText": "#FFF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0
        }
    }
},
{
    "id": 8,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 4,
        "enableTermsInfo": false,
        "checkoutOptions": [
            1
        ],
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 2,
        "menuTemplate": 1,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#000000",
            "primaryBg": "#F4ECDD",
            "color": "#9B5436",
            "primary": "#9B5436",
            "actionBtn": "#D5A286",
            "actionBtnText": "#FFFFFF",
            "warning": "#F44336",
            "success": "#E4BD80",
            "error": "#F44336",
            "fldBorder": "#212322",
            "fldColor": "#212322",
            "titleBg": "#D5A286",
            "titleText": "#FFFFFF",
            "confirmBoxBg": "#000000",
            "confirmBoxText": "#FFFFFF",
            "primaryBtn": "#9B5436",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#D5A286",
            "secondaryBtnText": "#F8F6F5",
            "infoBtn": "#E4BD80",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#D5A286",
            "accentBtnText": "#FFFFFF",
            "headerBg": "#D5A286",
            "headerText": "#FFFFFF",
            "separatorLine": "",
            "filterBg": "#E4BD80",
            "filterText": "#9B5436",
            "filterSelectBg": "#D5A286",
            "filterSelectText": "#FFFFFF"
        },
        "dark": {
            "bodyBg": "#0D7E83",
            "primaryBg": "#FFFFFF",
            "color": "#2F0A4D",
            "primary": "#4C8F80",
            "actionBtn": "#2F0A4D",
            "actionBtnText": "#FFFFFF",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#2F0A4D",
            "fldColor": "#000000",
            "titleBg": "#ECEDF4",
            "titleText": "#000000",
            "confirmBoxBg": "#ECEDF4",
            "confirmBoxText": "#000000",
            "primaryBtn": "#2F0A4D",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#2F0A4D",
            "secondaryBtnText": "#FFFFFF",
            "infoBtn": "#2F0A4D",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#2F0A4D",
            "accentBtnText": "#FFFFFF",
            "headerBg": "#ECEDF4",
            "headerText": "#FFF",
            "separatorLine": "",
            "filterBg": "#0D7E83",
            "filterText": "#7A65E1",
            "filterSelectBg": "#2F0A4D",
            "filterSelectText": "#FFF"
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},
{
    "id": 1,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#2A4A27",
            "primaryBg": "#FFFBDB",
            "color": "#2A4A27",
            "primary": "#2A4A27",
            "actionBtn": "#2A4A27",
            "actionBtnText": "#FFFFFF",
            "warning": "#FEC547",
            "success": "#2A4A27",
            "error": "#F44336",
            "fldBorder": "#2A4A27",
            "fldColor": "#2A4A27",
            "titleBg": "#E2DEB0",
            "titleText": "#2A4A27",
            "confirmBoxBg": "#E2DEBF",
            "confirmBoxText": "#2A4A27",
            "primaryBtn": "#2A4A27",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#2A4A27",
            "secondaryBtnText": "#FFFFFF",
            "infoBtn": "#2A4A27",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#2A4A27",
            "accentBtnText": "#FFFFFF",
            "headerBg": "#E2DEBF",
            "headerText": "#2A4A27",
            "separatorLine": "",
            "filterBg": "#E2DEBF",
            "filterText": "#2A4A27",
            "filterSelectBg": "#2A4A27",
            "filterSelectText": "#FFFFFF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},
{
    "id": 10,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#602D2E",
            "primaryBg": "#FFF5EA",
            "color": "#602D2E",
            "primary": "#602D2E",
            "actionBtn": "#602D2E",
            "actionBtnText": "#FFF5EA",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#602D2E",
            "fldColor": "#602D2E",
            "titleBg": "#ECEDF4",
            "titleText": "#000000",
            "confirmBoxBg": "#602D2E",
            "confirmBoxText": "#000000",
            "primaryBtn": "#602D2E",
            "primaryBtnText": "#FFF5EA",
            "secondaryBtn": "#602D2E",
            "secondaryBtnText": "#FFF5EA",
            "infoBtn": "#602D2E",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#602D2E",
            "accentBtnText": "#FFF5EA",
            "headerBg": "#602D2E",
            "headerText": "#FFF",
            "separatorLine": "",
            "filterBg": "#C9C9C2",
            "filterText": "#602D2E",
            "filterSelectBg": "#602D2E",
            "filterSelectText": "#FFFFFF00"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},
{
    "id": 6,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": false,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#2A4A27",
            "primaryBg": "#E5D6C2",
            "color": "#502115",
            "primary": "#2A4A27",
            "actionBtn": "#2A4A27",
            "actionBtnText": "#FFFFFF",
            "warning": "#F44336",
            "success": "#2A4A27",
            "error": "#F44336",
            "fldBorder": "#2A4A27",
            "fldColor": "#2A4A27",
            "titleBg": "#E2DEB0",
            "titleText": "#2A4A27",
            "confirmBoxBg": "#E2DEBF",
            "confirmBoxText": "#2A4A27",
            "primaryBtn": "#2A4A27",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#2A4A27",
            "secondaryBtnText": "#FFFFFF",
            "infoBtn": "#2A4A27",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#2A4A27",
            "accentBtnText": "#FFFFFF",
            "headerBg": "#502115",
            "headerText": "#2A4A27FF",
            "separatorLine": "",
            "filterBg": "#96B292",
            "filterText": "#502115",
            "filterSelectBg": "#2A4A27",
            "filterSelectText": "#FFFFFFFF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0
        }
    }
},
{
    "id": 3,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#06474A",
            "primaryBg": "#F1E5E1",
            "color": "#06474A",
            "primary": "#06474A",
            "actionBtn": "#06474A",
            "actionBtnText": "#F6AA4D",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#06474A",
            "fldColor": "#000000",
            "titleBg": "#D1B171",
            "titleText": "#000000",
            "confirmBoxBg": "#F6AA4D",
            "confirmBoxText": "#06474A",
            "primaryBtn": "#06474A",
            "primaryBtnText": "#F6AA4D",
            "secondaryBtn": "#06474A",
            "secondaryBtnText": "#F6AA4D",
            "infoBtn": "#F6AA4D",
            "infoBtnText": "#F6AA4D",
            "accentBtn": "#06474A",
            "accentBtnText": "#F6AA4D",
            "headerBg": "#06474A",
            "headerText": "#F6AA4DFF",
            "separatorLine": "",
            "filterBg": "#F6AA4D",
            "filterText": "#06474A",
            "filterSelectBg": "#06474A",
            "filterSelectText": "#D1B171FF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "home": 0,
            "confirmOrder": 0
        }
    }
},
{
    "id": 7,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "enableTerms": true,
        "homePageType": 3,
        "enableTermsInfo": true,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "themes": {
        "id": "",
        "light": {
            "bodyBg": "#0E3F3B",
            "primaryBg": "#FFFFFF",
            "color": "#000000",
            "primary": "#901C24",
            "actionBtn": "#901C24",
            "actionBtnText": "#000000",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#901C24",
            "fldColor": "#000000",
            "titleBg": "#CCCCC0",
            "titleText": "#000000",
            "confirmBoxBg": "#901C24",
            "confirmBoxText": "#000000",
            "primaryBtn": "#901C24",
            "primaryBtnText": "#000000",
            "secondaryBtn": "#901C24",
            "secondaryBtnText": "#000000",
            "infoBtn": "#901C24",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#901C24",
            "accentBtnText": "#000000",
            "headerBg": "#901C24",
            "headerText": "#CCCCC0FF",
            "separatorLine": "",
            "filterBg": "#ECECE4",
            "filterText": "#000000",
            "filterSelectBg": "#901C24",
            "filterSelectText": "#CCCCC0FF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0
        }
    }
}, {
    "id": 5,
    "name": "",
    "settings": {
        "logoPosition": 1,
        "homePageType": 3,
        "enableTermsInfo": false,
        "checkoutOptions": null,
        "showAboutInfo": true,
        "showLogo": true,
        "secondLvlTemplate": 0,
        "menuTemplate": 0,
        "hideTotalInCart": false,
        "menuInstruction": false
    },
    "helper": {
        "note": "",
        "termsLabel": "",
        "detailedTermsLabel": "",
        "aboutLabel": "Welcome!!",
        "aboutUs": "Your favourite pub has Monday to Friday happy hours! Enjoy our exquisite and exceptional service, Bangalore's beloved watering hole. At HOC we're all equals, one and the same-united by our quest for good food and drinks at great deals!"
    },
    "themes": {
        "id": "app-houseofcommons",
        "light": {
            "bodyBg": "#0D5262",
            "primaryBg": "#FFFFFF",
            "color": "#0D5262",
            "primary": "#0D5262",
            "actionBtn": "#0D5262",
            "actionBtnText": "#DC961D",
            "warning": "#F44336",
            "success": "#00FF00",
            "error": "#F44336",
            "fldBorder": "#0D5262",
            "fldColor": "#0D5262",
            "titleBg": "#0D5262",
            "titleText": "#000000",
            "confirmBoxBg": "#ECEDF4",
            "confirmBoxText": "#000000",
            "primaryBtn": "#2F0A4D",
            "primaryBtnText": "#FFFFFF",
            "secondaryBtn": "#0D5262",
            "secondaryBtnText": "#DC961D",
            "infoBtn": "#0D5262",
            "infoBtnText": "#FFFFFF",
            "accentBtn": "#0D5262",
            "accentBtnText": "#DC961D",
            "headerBg": "#0D5262",
            "headerText": "#0D5262FF",
            "separatorLine": "",
            "filterBg": "#0D5262",
            "filterText": "#E7A163",
            "filterSelectBg": "#DC961D",
            "filterSelectText": "#0D5262FF"
        },
        "dark": {
            "separatorLine": "",
            "filterBg": "",
            "filterText": "",
            "filterSelectBg": "",
            "filterSelectText": ""
        },
        "images": {
            "logo": 0,
            "bg": 0,
            "home": 0
        }
    }
}



]; 

export const  ThemesObj =  [
    { id: 11, type: "Regular-(Default)", themename: "Default Theme" },
    { id: 1, type: "Regular-(Default)", themename: "Light Green" },
    { id: 2, type: "Regular-(Default)", themename: "Blue and Yellow" },
    { id: 3, type: "Regular-(Default)", themename: "Rama green and yellow" },
    { id: 4, type: "Regular-(Default)", themename: "Bohemian(Pastel green and light brown)" },
    { id: 5, type: "Regular-(Default)", themename: "Blue and Yellow 2" },
    { id: 6, type: "Regular-(Default)", themename: "Pastel green and Maroon" }, 
    { id: 7, type: "Regular-(Default)", themename: "Red and cream" },
    { id: 8, type: "Block design- Upto category level", themename: "Brown and Cream" },
    { id: 9, type: "Block Design - All", themename: "Blue and Brown" },
    { id: 10, type: "Regular-(Default)", themename: "Maroon red and cream" }
    

];
export default {
    themes,
    ThemesObj
};